<template>
	<div
		class="wrapper item"
		:class="{ selected: selected }"
		style="border: 1px solid gray; min-width: 100px; max-width: 500px;"
	>
		<div
			class="fixed justify-content-center align-items-center"
			style="width: 120px; display: flex;"
		>
			<v-icon name="piggy-bank" scale="4" />
		</div>
		<div style="flex: 1 0;">
			<div class="title pt-2" style="">Defaultvärde</div>
			<div class="wrapper">
				<div style="flex: 1 0;">
					<Value :selected="selected" :name="t1" :value="v1" />
				</div>
				<div style="flex: 1 0;">
					<Value :selected="selected" :name="t2" :value="v2" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* tslint:disable */

import Value from "@/views/Value.vue";

export default {
	name: "ValueGroup",
	props: ["selected", "t1", "v1", "t2", "v2"],
	components: { Value },
};
</script>

<style scoped lang="scss">
.wrapper {
	display: flex;
	flex-flow: row wrap;
}
.fixed {
	flex-grow: 0;
	flex-shrink: 0;
}
.title {
	font-size: 1em;
	font-family: "Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica,
		sans-serif;
	font-weight: bold;
}

.selected {
	border-color: col("colors.Secondary");
	background-color: col("colors.Secondary");
	color: col("colors.White");
}

.selected * {
	border-color: col("colors.Secondary");
	background-color: col("colors.Secondary");
	color: col("colors.White");
}

.item:hover {
	border-color: col("colors.Secondary");
	color: col("colors.White");
	background-color: col("colors.Secondary");
	cursor: pointer;
}
.item:hover * {
	color: col("colors.White");
	background-color: col("colors.Secondary");
}
</style>
